import { Link } from 'react-router-dom';
import {
  Button,
  Card,
  CardContent,
  CardHeader,
  CardTitle,
  useTheme,
} from '@lognai/synapse-design-system-v2';
import { Logo } from '../../components/Logo';

export default function PartnerInviteExpiredPage() {
  const { theme } = useTheme();
  return (
    <Card className="w-full max-w-md">
      <CardHeader className="flex flex-col items-center space-y-4 text-center pb-6">
        <Logo variant={theme === 'light' ? 'dark' : 'white'} className="h-12 w-auto" />
        <CardTitle className="text-xl font-normal">Invitation Expired</CardTitle>
      </CardHeader>
      <CardContent className="space-y-4 text-center">
        <p className="text-sm text-muted-foreground">
          This invitation link has expired. Ask the company that invited you to send a new one.
        </p>
        <Link to="/login">
          <Button className="w-full">Go to Sign In</Button>
        </Link>
      </CardContent>
    </Card>
  );
}
